const appTypes = {
    RESET: 'APP/RESET',
};
export default appTypes;
